"use client";

import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
export function useQueryKeyListener(queryKey, callback) {
  const $ = _c(5);
  const queryClient = useQueryClient();
  let t0;
  let t1;
  if ($[0] !== callback || $[1] !== queryClient || $[2] !== queryKey) {
    t0 = () => {
      const unsubscribe = queryClient.getQueryCache().subscribe(event => {
        if (event?.query.queryKey === queryKey || Array.isArray(queryKey) && JSON.stringify(event?.query.queryKey) === JSON.stringify(queryKey)) {
          callback();
        }
      });
      return () => {
        unsubscribe();
      };
    };
    t1 = [queryClient, queryKey, callback];
    $[0] = callback;
    $[1] = queryClient;
    $[2] = queryKey;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
}